export var ELinkOpenMode;
(function (ELinkOpenMode) {
  ELinkOpenMode["Parent"] = "_parent";
  ELinkOpenMode["Blank"] = "_blank";
  ELinkOpenMode["Top"] = "_top";
  ELinkOpenMode["Self"] = "_self";
})(ELinkOpenMode || (ELinkOpenMode = {}));